if ($("header#header").length) {
  $('<span class="close"></span>').appendTo(".login-widget .popup-widget-inner #customerLogin");
  $("#customerLogin span.close").on("click", function () {
    $("body").removeClass("user-action-visible login-window-visible");
  });

  $(".header-top").append($(".top-navigation-bar .responsive-tools").clone());
  $(".header-top .responsive-tools").prepend($(".top-navigation-tools .dropdown").clone());
  $('body.mobile a[data-target="cart"]').removeClass("toggle-window");
  $('.navigation-buttons a[data-target="cart"]').clone().appendTo(".header-top .responsive-tools");

  loadFooter(appendContact);

  function appendContact() {

    $("#navigation").append($(".top-navigation-bar .top-navigation-bar-menu").clone());
    $("#navigation").append("<div class='contacts'></div>");
    $("#navigation .contacts").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
    $("#navigation .contacts li.tel").append(`<span class="info">${telefonInfo}</span>`);

    $(".header-top").append("<div class='contacts'></div>");
    $(".header-top .contacts").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
    $(".header-top .contacts li.tel").append(`<span class="info">${telefonInfo}</span>`);

  }


  if (!$("#cart-widget .emptyCart").length) {
    $("#cart-widget").append($("#footer .emptyCart").clone());
  }
  $(".header-top .responsive-tools").append($(".header-top .site-name-wrapper").clone());

  $(document).ready(function () {
    const $cartHoverArea = $(".responsive-tools a[data-target='cart'], .responsive-tools .cart-count");
    const $cartWidget = $("#cart-widget");
    const $body = $("body");
    let cartCloseTimeout = null;
    let isHoveringCartTrigger = false;
    let isHoveringCartWidget = false;

    function isDesktopCartHoverEnabled() {
      return window.matchMedia("(min-width: 992px)").matches;
    }

    function clearCartCloseTimeout() {
      if (cartCloseTimeout) {
        clearTimeout(cartCloseTimeout);
        cartCloseTimeout = null;
      }
    }

    function isInCartInteractionArea(element) {
      if (!element) {
        return false;
      }
      return $(element).closest(".responsive-tools a[data-target='cart'], .responsive-tools .cart-count, #cart-widget").length > 0;
    }

    function scheduleCartClose() {
      clearCartCloseTimeout();
      cartCloseTimeout = setTimeout(closeCartWidget, 60);
    }

    function isCartAreaHovered() {
      return isHoveringCartTrigger || isHoveringCartWidget;
    }

    function keepCartVisibleClasses() {
      $body.addClass("user-action-visible cart-window-visible");
      $cartWidget.css("display", "block");
    }

    function openCartWidget() {
      clearCartCloseTimeout();
      shoptet.popups.showPopupWindow("cart", true);
      keepCartVisibleClasses();
    }

    function closeCartWidget() {
      clearCartCloseTimeout();
      if (isCartAreaHovered()) {
        return;
      }

      if (shoptet?.popups && typeof shoptet.popups.hidePopupWindow === "function") {
        shoptet.popups.hidePopupWindow("cart");
      }
      $body.removeClass("cart-window-visible");
      $cartWidget.css("display", "none");
    }

    if (document.body) {
      const cartBodyClassObserver = new MutationObserver(function (mutations) {
        if (!isDesktopCartHoverEnabled()) {
          return;
        }

        const classChanged = mutations.some(function (mutation) {
          return mutation.attributeName === "class";
        });

        if (!classChanged || !isCartAreaHovered()) {
          return;
        }

        if (!$body.hasClass("cart-window-visible") || !$body.hasClass("user-action-visible")) {
          keepCartVisibleClasses();
        }
      });

      cartBodyClassObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    $cartHoverArea.off("mouseenter.cartHover mouseleave.cartHover");
    $cartHoverArea.on("mouseenter.cartHover", function () {
      isHoveringCartTrigger = true;
      if (isDesktopCartHoverEnabled()) {
        openCartWidget();
      }
    });

    $cartHoverArea.on("mouseleave.cartHover", function (event) {
      isHoveringCartTrigger = false;
      if (isDesktopCartHoverEnabled()) {
        if (isInCartInteractionArea(event.relatedTarget)) {
          clearCartCloseTimeout();
          return;
        }
        scheduleCartClose();
      }
    });

    $cartWidget.off("mouseenter.cartHover mouseleave.cartHover");
    $cartWidget.on("mouseenter.cartHover", function () {
      isHoveringCartWidget = true;
      if (isDesktopCartHoverEnabled()) {
        clearCartCloseTimeout();
        keepCartVisibleClasses();
      }
    });

    $cartWidget.on("mouseleave.cartHover", function (event) {
      isHoveringCartWidget = false;
      if (isDesktopCartHoverEnabled()) {
        if (isInCartInteractionArea(event.relatedTarget)) {
          clearCartCloseTimeout();
          return;
        }
        scheduleCartClose();
      }
    });
  });
}
